import {Outlet} from 'react-router-dom';

export function DashboardLayout() {
    return (
        <main className="studio-main" id="main-content">
            <div className="studio-main-inner"><Outlet /></div>
        </main>
    );
}
